import PreviewStylesCss from "../../../styles/PreviewStyles.css";

export const styles = (theme) => ({
  ...PreviewStylesCss,

  muListWrap: {
    padding: "10px",
    height: "calc(100% - 398px)",
    overflow: "auto",
    position: "absolute",
    width: "100%",
    top: "0",
    overflowX: "hidden",
    background: " #353535",
  },

  buttomOveridden: {
    "& .helpAddMargin": {
      // marginTop:"12px",
    },
  },
  muLabelsTrackPopOut: {
    minWidth: "170px",
    width:"inerit",
    textTransform: "uppercase",
    color: "#dcdcdc",
    fontSize: "0.7em",
    display: "inline-block",
    verticalAlign: "top",
    overflow: "hidden",
    textOverflow: "ellipsis",
    paddingLeft:"0"
  },
  popOutBlock: {
    background: "#424242",
    textAlign: "center",
    flex: "1",
    "& button": {
      fontSize: "12px",
      margin: "7px 11px 7px 0",
      background: "#0c853e",
      display: "block",
      padding: "13px 10px",
      width: "100%",
      "&:hover": {
        background: "#04923F",
      },
      "& svg": {
        fontSize: "2em",
        display: "block",
        margin: "0 auto 5px auto",
      },
      "& img": {
        display: "block",
        margin: "0 auto",
      },
    },
  },
  muDetails: {
    width: "80%",
    display: "inline-block",
    verticalAlign: "top",
    fontSize: "0.75em",
    wordBreak: "break-word",
    "& .MuiCircularProgress-colorPrimary": {
      color: "white",
      width: "20px !important",
      height: " 20px !important",
    },
  },
  progress: {
    width: "45px !important",
    height: " 45px !important",
    color: "green",
    position: "absolute",
    left: "0",
    right: "0",
    top: "50%",
    margin: "0 auto",
  },

  muLabelsBold: {
    fontWeight: "bold",
  },

  nonMCPSPPL: {
    color: "red",
    fontSize: "12px",
  },

  muDetailsBold: {
    fontWeight: "bold",
  },

  artworkHolder: {
    position: "relative",
    outline: "none",
    "&:hover > button": {
      display: "inline-block",
      opacity: "1",
    },
    "&:focus > button": {
      display: "inline-block",
      outline: "none",
      opacity: "1",
    },
    "&:active > button": {
      display: "inline-block",
      outline: "none",
      opacity: "1",
    },
    "&:hover >  span": {
      display: "inline-block",
      opacity: "1",
    },
    "& > span": {
      width: "40px",
      height: "40px",
      position: "absolute",
      // display:"none",
      opacity: "0",
      right: "45%",
      top: "40%",
      "&.Mui-focusVisible": {
        opacity: "1",
      },
    },
    "& button": {
      background: "#008135",
      width: "40px",
      height: "40px",
      boxShadow: "0 0 3px #000",
      "&:hover": {
        background: "#000",
      },
      position: "absolute",
      // display:"none",
      opacity: "0",
      right: "0",
      top: "40%",
      left: "0",
      margin: "0 auto",
      "&.Mui-focusVisible": {
        opacity: "1",
      },
    },
    // Added Breakpoints
    [theme.breakpoints.down("sm")]: {
      "& img": {
        width: "100%",
        height: "auto",
      },
    },
    [theme.breakpoints.up("md")]: {
      "& img": {
        width: "100% !important",
        height: "auto !important",
      },
    },
    [theme.breakpoints.up("lg")]: {
      "& img": {
        width: "160px!important",
        height: "160px !important",
      },
      "& .emptyArtwork": {
        width: "160px !important",
        height: "auto !important",
      },
    },
    "& .notPermitted": {
      position: "absolute",
      top: "50%",
      right: "0",
      bottom: "0",
      height: "18px",
      width: "18px",
      left: "0",
      margin: "0 auto",
      background: " rgba(0,0,0,0.5)",
      padding: "10px",
      borderRadius: "50px",
    },
  },

  commonTopButton: {
    padding: "9px",
    height: "32px",
    width: "32px",
    minWidth: "inherit",
    marginTop: "7px",
    marginLeft: "0px",
  },
  globalGrayButton: {
    background: "#545454",
    boxShadow: "none",
    color: "#fff",
    textTransform: "none",
    fontWeight: "400",
    margin: "0px 0px 0px 10px",
    fontSize: "12px",
    "&:hover": {
      background: "#393939",
      color: "#fff",
    },
  },

  panelHeader: {
    display: "flex",
    padding: "0 15px 0 0",
    background: "#242424",
    alignItems: "center",
    "& button": {
      verticalAlign: "middle",
      padding: "6px 8px 4px 9px",
      margin: "10px 5px 13px 10px",
      fontSize: "18px",
      background: "none",
      border: "1px solid #535353",
      borderRadius: "5px",
      color: "#fff",
    },
    "& button:hover": {
      background: "#000",
      cursor: "pointer",
    },
    "& h2": {
      width: "-webkit-fill-available",
      width: "100%",
      fontWeight: "500",
      whiteSpace: "nowrap",
      overflow: "hidden",
      maxWidth: "330px",
      textOverflow: "ellipsis",
      "& svg": {
        fontSize: "23px",
        verticalAlign: "middle",
        marginRight: "10px",
      },
    },
  },
  buttonCustomSize: {
    "& svg": {
      fontSize: "16px !important",
    },
  },
  muTitle: {
    color: "#fff",
    fontSize: "0.88em",
    fontWeight: "500",
    width: "-webkit-fill-available",
    width: "100%",
    padding: "10px 15px 10px 20px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    margin: "0",
    whiteSpace: "nowrap",
  },
  buildRuleRow: {
    border: "1px solid #737373",
    marginBottom: "5px",
    borderRadius: "3px",
    margin: "10px 0",
    padding: "10px",
  },
  buildEditorBlock: {
    fontSize: "12px",
    borderRadius: "3px",
    margin: "10px 0px 10px 0px",
    position: "absolute",
    height: "calc(100% - 88px)",
    overflow: "auto",
    right: "20px",
    padding: "20px",
    // width: "calc(100% - 50px)",
    left: "20px",
  },
  HistoryBlock: {
    fontSize: "1em",
    borderRadius: "3px",
    margin: "10px 0px 10px 0px",
    position: "absolute",
    height: "calc(100% - 388px)",
    overflow: "auto",
    right: "20px",
    paddingBottom: "20px",
    left: "20px",
  },
  ruleTriggerLabel: {
    color: "#FCE939",
    display: "inline-block",
    borderRadius: "3px",
    margin: "0 0 5px 0",
    textDecoration: "underline",
    display: "block",
    clear: "left",
  },
  trackHistory: {
    "& p": {
      fontSize: "12px",
    },
  },
  muDetailsBold: {
    fontWeight: "bold",
  },
  muDetails: {
    width: "80%",
    display: "inline-block",
    verticalAlign: "top",
    fontSize: "12px",
    wordBreak: "break-word",
    "& .MuiCircularProgress-colorPrimary": {
      color: "white",
      width: "20px !important",
      height: " 20px !important",
    },
  },
});
